export const isProductInOngoingGiveaways = (productId, ongoingGiveaways) => {
  return !!ongoingGiveaways && !!ongoingGiveaways.length && ongoingGiveaways.some(({
    products
  }) => {
    return !!products && products.find(product => (product === null || product === void 0 ? void 0 : product.toString()) === productId);
  });
};